import RouteParent from 'js/router/route-parent'

import AnalyticsIndex from 'js/pages/analytics/index.js'
import AnalyticsBiIndex from 'js/pages/analytics/bi-insight/index.js'
import AIAnalyticsIndex from 'js/pages/analytics/ai-analytics/index.js'
import AIInfinityIndex from 'js/pages/analytics/ai-infinity/index.js'

export default [
  {
    path: '/analytics',
    component: RouteParent,
    meta: {
      auth: false
    },
    children: [
      {
        path: '',
        name: 'analytics-index',
        component: AnalyticsIndex,
        meta: {
          auth: true,
          permit: ['SHOW_ANALYTICS']
        }
      },
      {
        path: '/bi-insight',
        name: 'analytics-bi-index',
        component: AnalyticsBiIndex,
        meta: {
          auth: true,
          permit: ['SHOW_ANALYTICS']
        }
      },
      {
        path: '/ai-analytics',
        name: 'ai-analytics-index',
        component: AIAnalyticsIndex,
        meta: {
          auth: true,
          permit: ['SHOW_ANALYTICS']
        }
      },
      {
        path: '/ai-infinity',
        name: 'ai-infinity-index',
        component: AIInfinityIndex,
        meta: {
          auth: true,
          permit: ['SHOW_ANALYTICS']
        }
      }
    ]
  }
]
